import "@css/app.css";

/* JS */
import "lazysizes";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]");

window.disableBodyScroll = disableBodyScroll;
window.enableBodyScroll = enableBodyScroll;

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

Alpine.plugin(collapse);
Alpine.start();

const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", appHeight);
appHeight();

const header = document.querySelector(".site-header");

const headerHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--header-height", `${header.offsetHeight}px`);
};
window.addEventListener("resize", headerHeight);
headerHeight();

var scrollLockEnabled = false;
let theNav = document.querySelector(".mobile-nav");
function shouldScrollLock() {
  if (!scrollLockEnabled) {
    disableBodyScroll(theNav);
  } else {
    enableBodyScroll(theNav);
  }
  scrollLockEnabled = !scrollLockEnabled;
}

window.shouldScrollLock = shouldScrollLock;

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import Swiper from "swiper";
import {
  Pagination,
  Navigation,
  EffectFade,
  Autoplay,
  Thumbs,
  Grid,
} from "swiper/modules";

Array.from(document.querySelectorAll(".js-slider-testimonials")).forEach(
  (container) => {
    const slider = container.querySelector(".swiper");
    const pagination = container.querySelector(".swiper-pagination");

    const swiper = new Swiper(slider, {
      modules: [Navigation, Pagination, EffectFade, Autoplay],
      loop: true,
      autoHeight: false,
      speed: 1000,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
);

// Initialize Swiper for newsletter carousels
Array.from(document.querySelectorAll(".newsletter-swiper")).forEach(
  (swiperElement) => {
    new Swiper(swiperElement, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 24,
      navigation: {
        nextEl: swiperElement.querySelector(".swiper-button-next"),
        prevEl: swiperElement.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
      loop: false,
      grabCursor: true,
    });
  }
);

// Initialize Swiper for team carousels
Array.from(document.querySelectorAll(".team-swiper")).forEach(
  (swiperElement) => {
    const progressBar = swiperElement.querySelector(
      ".team-swiper-progress-bar"
    );

    const swiper = new Swiper(swiperElement, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: swiperElement.querySelector(".swiper-button-next"),
        prevEl: swiperElement.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 16,
        },
        1563: {
          slidesPerView: 6,
          spaceBetween: 16,
        },
        1920: {
          slidesPerView: 7,
          spaceBetween: 16,
        },
      },
      loop: false,
      grabCursor: true,
      on: {
        progress: function (swiper, progress) {
          if (progressBar) {
            progressBar.style.width = `${progress * 100}%`;
          }
        },
        slideChange: function (swiper) {
          if (progressBar) {
            const progress = (swiper.activeIndex + 1) / swiper.slides.length;
            progressBar.style.width = `${progress * 200}%`;
          }
        },
        init: function (swiper) {
          if (progressBar) {
            const progress = 1 / swiper.slides.length;
            progressBar.style.width = `${progress * 200}%`;
          }
        },
      },
    });
  }
);

// Initialize Swiper for team-grid-slider (mobile only)
Array.from(document.querySelectorAll(".team-grid-slider-swiper")).forEach(
  (swiperElement) => {
    const progressBar = swiperElement.querySelector(
      ".team-grid-slider-progress-bar"
    );
    let swiperInstance = null;

    const initializeTeamGridSlider = () => {
      const isMobile = window.innerWidth < 768;

      // Destroy existing swiper if it exists
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }

      // Only initialize on mobile
      if (isMobile) {
        swiperInstance = new Swiper(swiperElement, {
          modules: [Navigation],
          slidesPerView: 1,
          spaceBetween: 16,
          navigation: {
            nextEl: swiperElement.querySelector(".swiper-button-next"),
            prevEl: swiperElement.querySelector(".swiper-button-prev"),
          },
          loop: false,
          grabCursor: true,
          on: {
            progress: function (swiper, progress) {
              if (progressBar) {
                progressBar.style.width = `${progress * 100}%`;
              }
            },
            slideChange: function (swiper) {
              if (progressBar) {
                const progress =
                  (swiper.activeIndex + 1) / swiper.slides.length;
                progressBar.style.width = `${progress * 100}%`;
              }
            },
            init: function (swiper) {
              if (progressBar) {
                const progress = 1 / swiper.slides.length;
                progressBar.style.width = `${progress * 100}%`;
              }
            },
          },
        });
      }
    };

    // Initialize on load
    initializeTeamGridSlider();

    // Reinitialize on resize (debounced)
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        initializeTeamGridSlider();
      }, 250);
    };
    window.addEventListener("resize", handleResize);
  }
);

// Initialize Swiper for text-image-section galleries
Array.from(document.querySelectorAll(".text-image-swiper")).forEach(
  (swiperElement) => {
    new Swiper(swiperElement, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      grabCursor: true,
      navigation: {
        nextEl: swiperElement.querySelector(".swiper-button-next"),
        prevEl: swiperElement.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: swiperElement.querySelector(".swiper-pagination"),
        clickable: true,
        type: "bullets",
      },
    });
  }
);

// Manual lazy loading function
const loadImagesInSlide = (slide) => {
  if (!slide) return;

  const lazyImages = slide.querySelectorAll(".lazy-image");
  lazyImages.forEach((img) => {
    if (img.dataset.src && !img.classList.contains("loaded")) {
      // Set the src and srcset
      img.src = img.dataset.src;
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
      }
      if (img.dataset.sizes) {
        img.sizes = img.dataset.sizes;
      }

      // Mark as loaded
      img.classList.add("loaded");

      // Hide preloader
      const preloader = img.nextElementSibling;
      if (preloader && preloader.classList.contains("lazy-preloader")) {
        preloader.style.display = "none";
      }
    }
  });
};

// Initialize gallery with thumbnail interaction
Array.from(document.querySelectorAll(".swiper-gallery-container")).forEach(
  (container) => {
    let currentSwiperInstances = {
      thumbSwiper: null,
      parentSwiper: null,
      childSwipers: [], // Will store child swipers by index
    };

    const initializeGallery = () => {
      const parentSlider = container.querySelector(".parent-slider");
      const mobileThumbSwiper = container.querySelector(".gallery-thumbs");

      // Destroy existing swiper instances
      if (currentSwiperInstances.thumbSwiper) {
        currentSwiperInstances.thumbSwiper.destroy(true, true);
        currentSwiperInstances.thumbSwiper = null;
      }
      if (currentSwiperInstances.parentSwiper) {
        currentSwiperInstances.parentSwiper.destroy(true, true);
        currentSwiperInstances.parentSwiper = null;
      }
      // Destroy child swipers
      currentSwiperInstances.childSwipers.forEach((swiper) => {
        if (swiper) swiper.destroy(true, true);
      });
      currentSwiperInstances.childSwipers = [];

      const isMobile = window.innerWidth <= 768;

      // Function to initialize a child slider
      const initializeChildSlider = (index) => {
        if (currentSwiperInstances.childSwipers[index]) {
          return currentSwiperInstances.childSwipers[index]; // Already initialized
        }

        const childSlider = parentSlider.querySelector(
          `.swiper-slide:nth-child(${index + 1}) .child-slider`
        );
        if (!childSlider) return null;

        const childSwiper = new Swiper(childSlider, {
          modules: [Pagination, Navigation, Thumbs],
          loop: true,
          slidesPerView: 1,
          allowTouchMove: true,
          pagination: {
            el: ".swiper-pagination-child",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          on: {
            slideChange: function () {
              // Load images for the current slide
              const currentSlide = this.slides[this.activeIndex];
              loadImagesInSlide(currentSlide);
            },
            init: function () {
              // Load images for the initial slide
              const currentSlide = this.slides[this.activeIndex];
              loadImagesInSlide(currentSlide);
            },
          },
        });

        currentSwiperInstances.childSwipers[index] = childSwiper;

        // Memory management: Clean up old child sliders (keep only 3 active)
        const maxActiveSliders = 3;
        const activeSliders = Object.keys(
          currentSwiperInstances.childSwipers
        ).filter((key) => currentSwiperInstances.childSwipers[key] !== null);

        if (activeSliders.length > maxActiveSliders) {
          // Find the oldest slider (not the current one)
          const oldestIndex = activeSliders.find(
            (sliderIndex) => parseInt(sliderIndex) !== index
          );

          if (oldestIndex && currentSwiperInstances.childSwipers[oldestIndex]) {
            currentSwiperInstances.childSwipers[oldestIndex].destroy(
              true,
              true
            );
            currentSwiperInstances.childSwipers[oldestIndex] = null;
          }
        }

        return childSwiper;
      };

      if (isMobile) {
        // Mobile: Initialize thumbnail swiper
        currentSwiperInstances.thumbSwiper = new Swiper(mobileThumbSwiper, {
          modules: [Navigation],
          slidesPerView: "auto",
          spaceBetween: 8,
          freeMode: false,
          watchSlidesProgress: true,
          allowTouchMove: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });

        // Mobile: Initialize parent slider
        currentSwiperInstances.parentSwiper = new Swiper(parentSlider, {
          modules: [Pagination, EffectFade],
          loop: false,
          slidesPerView: 1,
          allowTouchMove: false,
          noSwiping: true,
          effect: "fade",
          fadeEffect: { crossFade: true },
          speed: 500,
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
          pagination: { el: ".swiper-pagination-parent", clickable: true },
          on: {
            slideChange: function () {
              // Initialize child slider for the current slide
              const activeIndex = this.activeIndex;
              initializeChildSlider(activeIndex);
            },
            init: function () {
              // Initialize child slider for the first slide
              initializeChildSlider(0);
            },
          },
        });

        // Mobile: Add click handlers to mobile thumbnails
        const mobileThumbItems =
          mobileThumbSwiper.querySelectorAll(".thumbnail-item");
        mobileThumbItems.forEach((thumbnail, index) => {
          thumbnail.addEventListener("click", () => {
            mobileThumbItems.forEach((item) => item.classList.remove("active"));
            thumbnail.classList.add("active");
            currentSwiperInstances.parentSwiper.slideTo(index);
            setTimeout(() => {
              currentSwiperInstances.parentSwiper.update();
            }, 100);
          });
        });

        // Set first mobile thumbnail as active by default
        if (mobileThumbItems.length > 0) {
          mobileThumbItems[0].classList.add("active");
        }

        // Update active thumbnail when parent slider changes
        currentSwiperInstances.parentSwiper.on("slideChange", () => {
          const activeIndex = currentSwiperInstances.parentSwiper.activeIndex;
          mobileThumbItems.forEach((item, index) => {
            item.classList.toggle("active", index === activeIndex);
          });
        });
      } else {
        // Desktop: Initialize parent slider with fade effect
        const desktopParentSlider = container.querySelector(".parent-slider");
        currentSwiperInstances.parentSwiper = new Swiper(desktopParentSlider, {
          modules: [EffectFade],
          loop: false,
          slidesPerView: 1,
          allowTouchMove: false,
          noSwiping: true,
          effect: "fade",
          fadeEffect: { crossFade: true },
          speed: 500,
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
          on: {
            slideChange: function () {
              // Initialize child slider for the current slide
              const activeIndex = this.activeIndex;
              initializeChildSlider(activeIndex);
            },
            init: function () {
              this.slideTo(0);
              // Initialize child slider for the first slide
              initializeChildSlider(0);
            },
          },
        });

        // Select only desktop thumbnails
        const desktopThumbnailItems = container.querySelectorAll(
          ".gallery-thumbs-grid .thumbnail-item"
        );

        // Add click handlers to desktop thumbnails
        desktopThumbnailItems.forEach((thumbnail, index) => {
          thumbnail.addEventListener("click", () => {
            desktopThumbnailItems.forEach((item) =>
              item.classList.remove("active")
            );
            thumbnail.classList.add("active");
            currentSwiperInstances.parentSwiper.slideTo(index);
            setTimeout(() => {
              currentSwiperInstances.parentSwiper.update();
            }, 100);
          });
        });

        // Set first thumbnail as active by default
        if (desktopThumbnailItems.length > 0) {
          desktopThumbnailItems[0].classList.add("active");
        }

        // Update active thumbnail when parent slider changes
        currentSwiperInstances.parentSwiper.on("slideChange", () => {
          const activeIndex = currentSwiperInstances.parentSwiper.activeIndex;
          desktopThumbnailItems.forEach((item, index) => {
            item.classList.toggle("active", index === activeIndex);
          });
        });

        // Ensure first thumbnail is active after initialization
        setTimeout(() => {
          if (desktopThumbnailItems.length > 0) {
            desktopThumbnailItems.forEach((item) =>
              item.classList.remove("active")
            );
            desktopThumbnailItems[0].classList.add("active");
            currentSwiperInstances.parentSwiper.slideTo(0);
          }
        }, 100);
      }
    };

    // Initialize on load and reinitialize on resize
    initializeGallery();

    // Improved debouncing with breakpoint detection
    let resizeTimeout;
    let isResizing = false;
    let currentBreakpoint = window.innerWidth <= 768 ? "mobile" : "desktop";
    let lastWindowWidth = window.innerWidth;

    const debouncedResize = () => {
      if (!isResizing) {
        isResizing = true;
        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(() => {
          const newWindowWidth = window.innerWidth;
          const newBreakpoint = newWindowWidth <= 768 ? "mobile" : "desktop";

          // Only reinitialize if breakpoint changed or significant width change
          const widthChange = Math.abs(newWindowWidth - lastWindowWidth);
          const breakpointChanged = newBreakpoint !== currentBreakpoint;
          const significantChange = widthChange > 50; // 50px threshold

          if (breakpointChanged || significantChange) {
            initializeGallery();
            currentBreakpoint = newBreakpoint;
            lastWindowWidth = newWindowWidth;
          }

          isResizing = false;
        }, 250); // Reduced debounce time for better responsiveness
      }
    };

    window.addEventListener("resize", debouncedResize);

    // Cleanup function for memory management
    const cleanup = () => {
      clearTimeout(resizeTimeout);
      window.removeEventListener("resize", debouncedResize);
    };

    // Cleanup on page unload
    window.addEventListener("beforeunload", cleanup);
  }
);

class InlineVideo {
  constructor(el) {
    this._el = el;
    this._video = el.dataset.video;
    this._image = el.querySelector(".js-video__placeholder");

    this._el.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick() {
    this._el.insertAdjacentHTML(
      "beforeend",
      `<iframe src="${this._video}?autoplay=1&rel=0" frameborder="0"></iframe>`
    );
    this._image.classList.add("fade-out");

    setTimeout(() => {
      this._image.remove();
    }, 700);

    this._el.removeEventListener("click", this.handleClick);
  }
}

Array.from(document.querySelectorAll(".js-video")).forEach((video) => {
  new InlineVideo(video);
});

document.addEventListener("onFormieInit", (event) => {
  let Formie = event.detail.formie;
  let formEls = Formie.$forms ?? [];
  formEls.forEach((el) => {
    Formie.refreshForCache(el.id);
  });
});

/* scroll image */
let scrollImageObserver = null;

const initScrollImage = () => {
  // Create observer if it doesn't exist
  if (!scrollImageObserver) {
    scrollImageObserver = new IntersectionObserver(
      (entries) => {
        // Group intersecting entries by their container
        const containerGroups = new Map();

        entries.forEach((entry) => {
          if (entry.isIntersecting && !entry.target.classList.contains("scrolled")) {
            const container = findStaggerContainer(entry.target);
            const key = container || document.body;
            
            if (!containerGroups.has(key)) {
              containerGroups.set(key, []);
            }
            containerGroups.get(key).push(entry.target);
          }
        });

        // Process each group with stagger
        containerGroups.forEach((elements) => {
          // Get all scroll-image siblings in the same container that are visible
          if (elements.length === 0) return;

          const container = findStaggerContainer(elements[0]);
          const allSiblings = Array.from(
            container.querySelectorAll(".scroll-image")
          ).filter((el) => !el.classList.contains("scrolled"));

          // Get visible siblings (in viewport or close to it)
          const visibleSiblings = allSiblings.filter((el) => {
            const rect = el.getBoundingClientRect();
            return rect.top < window.innerHeight + 150;
          });

          // Sort by position in DOM
          visibleSiblings.sort((a, b) => {
            const aRect = a.getBoundingClientRect();
            const bRect = b.getBoundingClientRect();
            // Sort by top position, then left position
            return aRect.top - bRect.top || aRect.left - bRect.left;
          });

          // Apply stagger to visible siblings
          visibleSiblings.forEach((el, index) => {
            if (!el.classList.contains("scrolled")) {
              el.style.setProperty("--stagger-delay", index);
              requestAnimationFrame(() => {
                el.classList.add("scrolled");
              });
              scrollImageObserver.unobserve(el);
            }
          });
        });
      },
      {
        threshold: 0.15, // Trigger when 15% visible - Google's typical threshold
        rootMargin: "0px 0px -50px 0px", // Start animation slightly before element enters viewport
      }
    );
  }

  // Find all scroll-image elements that aren't already being observed
  const images = document.querySelectorAll(".scroll-image");
  images.forEach((img) => {
    // Only observe if not already scrolled and not already observed
    if (!img.classList.contains("scrolled")) {
      scrollImageObserver.observe(img);
    }
  });
};

// Find the appropriate container for stagger grouping
const findStaggerContainer = (element) => {
  // Look for common parent containers (grid, list, section, etc.)
  let parent = element.parentElement;
  const maxDepth = 6;
  let depth = 0;

  while (parent && depth < maxDepth && parent !== document.body) {
    // Check if this parent has multiple scroll-image descendants
    const scrollImages = parent.querySelectorAll(".scroll-image");
    if (scrollImages.length > 1) {
      // Check if it's a meaningful container (has class or is a semantic element)
      const tagName = parent.tagName.toLowerCase();
      if (
        parent.classList.length > 0 ||
        ["section", "article", "div", "ul", "ol", "main"].includes(tagName)
      ) {
        return parent;
      }
    }
    parent = parent.parentElement;
    depth++;
  }

  // Fallback: return the immediate parent or body
  return element.parentElement || document.body;
};

// Initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initScrollImage);
} else {
  initScrollImage();
}

// Expose function for re-initialization when elements are added dynamically
window.initScrollImage = initScrollImage;
